/**
 * @ComponentFor Avensia.Shop.Features.Search.Pages.Search.SearchPageViewModel
 */
import React from "react";
import classnames from "classnames";
import connect from "Shared/connect";
import { parseUrl } from "Shared/url";
import Main from "Shared/PageLayout";
import ProductListing from "Shared/ProductListing";
import ContentCardRow from "Shared/ContentCardRow";
import { translate } from "Shared/translate";
import * as styles from "./base.scss";
import CategoryList from "./CategoryList";
import ContentList from "./ContentList";
import CompletionList from "./CompletionList";
import SearchPageHeader from "./Components/SearchPageHeader";
import { SMALL } from "Shared/breakpoints";
import { updateODPTrackingSearchPage } from "../../../TrackingInformation";
class SearchPage extends React.Component {
    focusDiv() {
        this.wrapper.focus();
    }
    componentDidUpdate() {
        updateODPTrackingSearchPage(this.props.searchPhrase);
    }
    componentDidMount() {
        updateODPTrackingSearchPage(this.props.searchPhrase);
        this.focusDiv();
    }
    facetClicked() {
        this.focusDiv();
    }
    getQueryParams() {
        const currentUrl = parseUrl(window.location);
        if (currentUrl.query && currentUrl.query["q"]) {
            return { q: currentUrl.query["q"] };
        }
        else {
            return {};
        }
    }
    visibleProductCount() {
        // TODO - a bad fix - maybe refactor this
        let current = this.props.countPerPage;
        if (this.props.products.products.length / 2 > current) {
            return this.props.products.products.length;
        }
        return current;
    }
    mayHaveAndFilter() {
        /** Since filter is applied optimistically we want to rule out the possibility
         * that it could be set by waiting for page request to be resolved */
        return (this.props.currentPageIsLoading ||
            this.props.products.facets.some((f) => f.hasAndFilter));
    }
    getActiveConcept() {
        if (!!!this.props.products.conceptFacets)
            return null;
        if (this.props.products.conceptFacets.map(c => c.facetValueSettings).length == 0)
            return null;
        const facetSettings = this.props.products.conceptFacets.map(c => c.facetValueSettings)
            .reduce((acc, settings) => acc.concat(settings))
            .filter(function (value, index, self) {
            return index === self.findIndex(function (x) {
                return x.original && x.original.id === value.original.id;
            });
        });
        return !!facetSettings && !!facetSettings.length ?
            facetSettings.find(x => !!x.original.selected) : null;
    }
    render() {
        const searchSuggestions = this.props.searchSuggestions || [];
        const hasContent = this.props.categories.length > 0 ||
            this.props.content.length > 0 ||
            this.props.completions.length > 0;
        return (React.createElement(Main, { appearance: "narrow" },
            React.createElement("div", { tabIndex: 0, ref: (el) => (this.wrapper = el) },
                React.createElement("div", { className: this.props.searchPhrase && hasContent && styles.bottomBorder },
                    React.createElement(SearchPageHeader, { products: this.props.products, searchSuggestions: this.props.searchSuggestions, hasContent: hasContent, searchPhrase: this.props.searchPhrase, page: this.props.page, activeConcept: this.getActiveConcept() })),
                this.props.products.totalProductCount === 0 &&
                    !this.mayHaveAndFilter() ? (React.createElement("div", null, !!this.props.searchPhrase && !!hasContent && (React.createElement("div", { className: classnames(styles.lists, styles.noProducts) },
                    this.props.categories.length > 0 && (React.createElement(CategoryList, { categories: this.props.categories, searchPhrase: this.props.searchPhrase })),
                    this.props.searchPhrase.length > 0 && (React.createElement(ContentList, { content: this.props.content, searchPhrase: this.props.searchPhrase })),
                    this.props.completions.length > 0 && (React.createElement(CompletionList, { completions: this.props.completions, searchPhrase: this.props.searchPhrase })))))) : (React.createElement(ProductListing, Object.assign({ className: classnames({
                        [styles.hasDidYouMean]: searchSuggestions.length > 0,
                    }), facetClicked: () => this.facetClicked() }, this.props, { queryParams: this.getQueryParams(), disableHeaderRow: true, showLayoutOptions: this.props.currentBreakpoint > SMALL, searchTerm: this.props.searchPhrase }))),
                React.createElement(ContentCardRow, { cards: this.props.cards, title: translate("/Product/LatestNews") }))));
    }
}
export default connect((state) => ({
    currentPageIsLoading: state.currentPage.isLoading,
    currentUser: state.currentUser,
    currentBreakpoint: state.currentBreakpoint
}))(SearchPage);
